module.exports = __webpack_public_path__ + "img/reklamanyag-gyartas.97543a52.jpg";